import { WalletVault } from '@bz/wallet/';

export const route = {
  info: {
    login: true,
  },
} satisfies RouteDefinition;
export default WalletVault;
